import type {OperatorOption} from '@cypro/ui/components/ui/multi-filter/schemas'
import {LuBriefcaseMedical, LuLayers, LuSettings, LuShield, LuSquareUser} from 'react-icons/lu'

export const OPERATORS = {
  regular: [
    {label: 'filter_has_any_of', value: 'IN'},
    {label: 'filter_has_none_of', value: 'NOT IN'},
    {label: 'filter_is_empty', value: 'IS EMPTY'},
    {label: 'filter_is_not_empty', value: 'IS NOT EMPTY'},
  ],
  date: [
    {label: 'filter_is', value: '='},
    {label: 'filter_is_not', value: '!='},
    {label: 'filter_is_before', value: '<'},
    {label: 'filter_is_after', value: '>'},
    {label: 'filter_is_on_or_before', value: '<='},
    {label: 'filter_is_on_or_after', value: '>='},
    {label: 'filter_is_between', value: 'IS BETWEEN'},
    {label: 'filter_is_empty', value: 'IS EMPTY'},
    {label: 'filter_is_not_empty', value: 'IS NOT EMPTY'},
  ],
} satisfies Record<'regular' | 'date', OperatorOption[]>

export const CRITERIA_TYPES = {
  status: 'regular',
  resource: 'regular',
  domain: 'regular',
  action: 'regular',
  performedBy: 'regular',
  performedAt: 'date',
} as const

export const TIMELINE_ICONS = {
  auth: LuShield,
  patient: LuSquareUser,
  hl7: LuBriefcaseMedical,
  configuration: LuSettings,
  misc: LuLayers,
} as const
